import { APIVersion, axios } from "../../Config/config.js";
const sharedBaseUrl = "https://shared.dev.silal.app";
// axios.defaults.baseURL = basePath;

const getCategories = async (payload) => {
  return await axios.get(`${sharedBaseUrl}${APIVersion}categories/0`, payload);
};
const getSingleCategory = async (category_id) => {
  return await axios.get(
    `${sharedBaseUrl}${APIVersion}categories/${category_id}/`
  );
};
const addCategory = async (payload) => {
  return await axios.post(`${APIVersion}categories/`, payload);
};

const editCategory = async (payload) => {
  return await axios.put(`${APIVersion}categories/${payload.id}/`, payload);
};

const deleteCategory = async (payload) => {
  const res = await axios.delete(`${APIVersion}categories/`, { data: payload });
  return res;
};

const hideCategory = async (payload) => {
  const res = await axios.delete(
    `${APIVersion}categories/hide/${payload.category_id}/`
  );
  return res;
};

const unhideCategory = async (payload) => {
  const res = await axios.put(
    `${APIVersion}categories/unhide/${payload.category_id}/`
  );
  return res;
};

const add_new_attribute_bool = async (payload) => {
  return await axios.post(
    `${APIVersion}categories/${payload.category_id}/attributes/boolean/`,
    payload
  );
};

const add_new_attribute_text = async (payload) => {
  return await axios.post(
    `${APIVersion}categories/${payload.category_id}/attributes/select/`,
    payload
  );
};

const add_new_attribute_num = async (payload) => {
  return await axios.post(
    `${APIVersion}categories/${payload.category_id}/attributes/numeric/`,
    payload
  );
};

const edit_attribute = async (payload) => {
  payload.new_name = payload.name;
  return await axios.put(`${APIVersion}attributes/${payload.id}/`, payload);
};

const append_attribute_values = async (payload) => {
  return await axios.put(
    `${APIVersion}attributes/values/${payload.id}/`,
    payload
  );
};

const create_progress_monitor = async () => {
  return await axios.post(
    `${APIVersion}progress/create_progress_monitoring_record/`
  );
};

const get_progress_monitor = async (monitorId) => {
  console.log("received");

  return await axios.get(`${APIVersion}progress/${monitorId}/`);
};

export {
  getCategories,
  getSingleCategory,
  addCategory,
  editCategory,
  deleteCategory,
  hideCategory,
  unhideCategory,
  add_new_attribute_bool,
  add_new_attribute_text,
  add_new_attribute_num,
  edit_attribute,
  append_attribute_values,
  create_progress_monitor,
  get_progress_monitor,
};
